<template>
  <div>
    <Form
      ref="formValidate"
      :label-width="120"
    >
    <FormItem label="创建者:">
      <label>{{username}}</label>
    </FormItem>

    <FormItem label="执行账号:">
      <label>{{nickname}}</label>
    </FormItem>

    <FormItem label="工作类型:">
      <label>{{work_type}}</label>
    </FormItem>

    <FormItem label="分类:">
      <label>{{video_classify}}</label>
    </FormItem>

    <FormItem label="视频语言:">
      <label>{{language}}</label>
    </FormItem>

    <FormItem label="原视频链接地址:">
      <a target="_blank" :href="video_url">打开</a>
    </FormItem>

    <FormItem label="视频下载地址:">
      <a target="_blank" :href="url">下载</a>
    </FormItem>

    <FormItem label="视频标题:">
      <label>{{video_title}}</label>
    </FormItem>

    <FormItem label="视频简介:">
      <label>{{video_desc}}</label>
    </FormItem>
    
    <template v-for="(item, index) in goodItems">
        <FormItem
                :label="'金句评论:' + (index + 1)">
            <Row>
                <Col span="18">
                    <label>{{item.value}}</label>
                </Col>
            </Row>
        </FormItem>
    </template>

    <template v-for="(item, index) in blackItems">
        <FormItem
                :label="'黑粉评论:' + (index + 1)">
            <Row>
                <Col span="18">
                    <label>{{item.value}}</label>
                </Col>
            </Row>
        </FormItem>
    </template>

  </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'

export default {
  components: { params },
  data () {
    return {
      work_type:'',
      username:'',
      nickname:'',
      video_url:'',
      video_title:'',
      video_desc:'',
      video_classify:'',
      language:'',
      url:'',
      blackItems:[],
      goodItems:[]
    }
  },
  watch: {
  },
  methods: {
    open(){
      window.open(this.video_url, '_blank');
    },
    download(){
      window.open(this.url, '_blank');
    },
    setDetail(params){
      this.username = params.username
      this.nickname = params.nickname
      this.work_type = params.work_type_name
      this.video_classify = params.video_classify
      this.video_url = params.video_url
      this.video_title = params.video_title
      this.video_desc = params.video_desc
      this.language = params.language
      this.url = params.url
      this.goodItems = JSON.parse(params.good_comment)
      this.blackItems = JSON.parse(params.black_comment)

    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
